export const makeResources = (m = 0, c = 0, d = 0, e = 0) => {
    return {
        metal: m,
        crystal: c,
        deuterium: d,
        energy: e,
    }
  }

export const timesResources = (res, factor) => {
return {
    metal: res.metal * factor,
    crystal: res.crystal * factor,
    deuterium: res.deuterium * factor,
    energy: res.energy * factor,
}
}

export const addResources = (res1, res2) => {
return {
    metal: res1.metal + res2.metal,
    crystal: res1.crystal + res2.crystal,
    deuterium: res1.deuterium + res2.deuterium,
    energy: res1.energy + res2.energy
}
}

export const roundResources = (res) => {
return {
    metal: Math.round(res.metal),
    crystal: Math.round(res.crystal),
    deuterium: Math.round(res.deuterium),
    energy: Math.round(res.energy),
}
}

export const ceilResources = (res) => {
return {
    metal: Math.ceil(res.metal),
    crystal: Math.ceil(res.crystal),
    deuterium: Math.ceil(res.deuterium),
    energy: Math.ceil(res.energy),
}
}